import { authManager } from '../auth-manager.js';
import { escapeHTML } from '../security.js';

export async function renderFeedbackView(container, syncManager) {
  let selectedRating = 5;
  let userFeedbacks = [];

  try {
    const res = await authManager.fetchWithAuth('/api/feedbacks/my');
    if (res.ok) {
      userFeedbacks = await res.json();
    }
  } catch (err) {
    console.warn('Failed to load user feedbacks:', err);
  }

  const renderStarRating = (currentRating) => {
    let starsHtml = '';
    for (let i = 1; i <= 5; i++) {
      const isFilled = i <= currentRating;
      starsHtml += `
        <button type="button" class="star-btn ${isFilled ? 'active' : ''}" data-rating="${i}" aria-label="${i} estrelas" style="background: none; border: none; cursor: pointer; padding: 0.2rem;">
          <span class="material-symbols-outlined" style="font-size: 32px; color: ${isFilled ? '#F59E0B' : '#CBD5E1'}; font-variation-settings: 'FILL' ${isFilled ? 1 : 0};">star</span>
        </button>
      `;
    }
    return starsHtml;
  };

  const renderFeedbackList = (feedbacks) => {
    if (!feedbacks || feedbacks.length === 0) {
      return `
        <div class="chart-card text-center text-muted" style="padding: 2rem 1rem; font-size: 0.875rem;">
          Você ainda não enviou nenhum comentário.
        </div>
      `;
    }

    return feedbacks.map(fb => {
      const dateStr = fb.createdAt ? new Date(fb.createdAt).toLocaleDateString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
      }) : '';

      let stars = '';
      for (let i = 1; i <= 5; i++) {
        const isFilled = i <= fb.rating;
        stars += `<span class="material-symbols-outlined" style="font-size: 16px; color: ${isFilled ? '#F59E0B' : '#CBD5E1'}; font-variation-settings: 'FILL' ${isFilled ? 1 : 0};">star</span>`;
      }

      const replyHtml = fb.reply ? `
        <div class="feedback-reply-box" style="background: #F8FAFC; border-left: 3px solid #10B981; padding: 0.65rem 0.85rem; border-radius: 0.5rem; margin-top: 0.6rem;">
          <div style="display: flex; align-items: center; gap: 0.4rem; font-weight: 700; font-size: 0.78rem; color: #047857; margin-bottom: 0.25rem;">
            <span class="material-symbols-outlined" style="font-size: 16px;">forum</span>
            Resposta da Equipe
          </div>
          <p style="font-size: 0.85rem; color: #111827; line-height: 1.4; margin: 0;">
            ${escapeHTML(fb.reply)}
          </p>
        </div>
      ` : `
        <div style="font-size: 0.75rem; color: #64748B; margin-top: 0.5rem; font-style: italic;">
          Aguardando análise da equipe...
        </div>
      `;

      return `
        <div class="chart-card feedback-card" style="margin-bottom: 1rem; padding: 1.25rem;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
            <div style="display: flex; align-items: center; gap: 0.2rem;">
              ${stars}
            </div>
            <span style="font-size: 0.75rem; color: #64748B;">${escapeHTML(dateStr)}</span>
          </div>
          <p style="font-size: 0.9rem; color: #111827; line-height: 1.5; margin: 0 0 0.5rem 0;">
            ${escapeHTML(fb.comment)}
          </p>
          ${replyHtml}
        </div>
      `;
    }).join('');
  };

  container.innerHTML = `
    <!-- Header & Back Button -->
    <div class="detail-header" style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1.25rem;">
      <button class="detail-back" id="btn-back" style="background: #ECEAE3; border: none; color: #111827; cursor: pointer; padding: 0.45rem; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
        <span class="material-symbols-outlined" style="font-size: 20px;">arrow_back</span>
      </button>
      <div>
        <h2 style="margin: 0; font-size: clamp(1.25rem, 4.5vw, 1.6rem); font-weight: 800; color: #111827; line-height: 1.2;">Enviar Feedback</h2>
        <p class="text-muted" style="margin: 0.15rem 0 0 0; font-size: 0.82rem;">Sua opinião é fundamental para aprimorarmos o NF Tracker.</p>
      </div>
    </div>

    <!-- Form Panel -->
    <div class="chart-card" style="padding: 1.5rem; margin-bottom: 1.5rem;">
      <form id="feedback-form">
        <div style="margin-bottom: 1.25rem; text-align: center;">
          <label style="display: block; font-weight: 700; font-size: 0.9rem; margin-bottom: 0.5rem; color: #111827;">
            Como você avalia sua experiência com o app?
          </label>
          <div id="star-rating-container" style="display: inline-flex; gap: 0.25rem;">
            ${renderStarRating(selectedRating)}
          </div>
        </div>

        <div style="margin-bottom: 1.25rem;">
          <label for="feedback-comment" style="display: block; font-weight: 700; font-size: 0.82rem; margin-bottom: 0.4rem; color: #111827;">
            Comentários ou Sugestões
          </label>
          <textarea 
            id="feedback-comment" 
            rows="4" 
            placeholder="Conte-nos o que funcionou bem ou o que pode ser melhorado..." 
            style="width: 100%; box-sizing: border-box; background: #FFFFFF; border: 1px solid var(--color-border); border-radius: 0.75rem; color: #111827; padding: 0.75rem 1rem; font-family: inherit; font-size: 0.875rem; resize: vertical; outline: none;"
            required
          ></textarea>
        </div>

        <button type="submit" id="btn-submit-feedback" class="btn btn-primary" style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 0.5rem; padding: 0.8rem 1rem; font-weight: 700; border-radius: var(--radius-pill); font-size: 0.875rem;">
          <span class="material-symbols-outlined" style="font-size: 18px;">send</span>
          Enviar Feedback
        </button>
      </form>
    </div>

    <!-- History Section -->
    <div style="margin-bottom: 1.5rem;">
      <h3 style="font-size: 1.05rem; font-weight: 800; color: #111827; margin: 0 0 0.85rem 0; display: flex; align-items: center; gap: 0.4rem;">
        <span class="material-symbols-outlined" style="color: #D97706; font-size: 20px;">history</span>
        Seus Feedbacks Anteriores
      </h3>
      <div id="user-feedbacks-container">
        ${renderFeedbackList(userFeedbacks)}
      </div>
    </div>
  `;

  // Bind Back Button
  container.querySelector('#btn-back')?.addEventListener('click', () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.hash = '#notas';
    }
  });

  // Bind Star Rating Buttons
  const starContainer = container.querySelector('#star-rating-container');
  starContainer?.addEventListener('click', (e) => {
    const btn = e.target.closest('.star-btn');
    if (btn) {
      selectedRating = parseInt(btn.dataset.rating, 10);
      starContainer.innerHTML = renderStarRating(selectedRating);
    }
  });

  // Bind Form Submit
  const form = container.querySelector('#feedback-form');
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const commentEl = container.querySelector('#feedback-comment');
    const commentText = commentEl?.value.trim();
    if (!commentText) return;

    const submitBtn = container.querySelector('#btn-submit-feedback');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <span class="material-symbols-outlined spin">progress_activity</span>
        Enviando...
      `;
    }

    try {
      const res = await authManager.fetchWithAuth('/api/feedbacks', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rating: selectedRating, comment: commentText })
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || 'Erro ao enviar feedback');
      }

      const newFb = await res.json();
      userFeedbacks.unshift(newFb);

      // Reset form
      commentEl.value = '';
      selectedRating = 5;
      starContainer.innerHTML = renderStarRating(selectedRating);

      // Re-render history
      const historyContainer = container.querySelector('#user-feedbacks-container');
      if (historyContainer) {
        historyContainer.innerHTML = renderFeedbackList(userFeedbacks);
      }

      if (syncManager && syncManager.showToast) {
        syncManager.showToast('Obrigado! Seu feedback foi enviado com sucesso.', 'success');
      }
    } catch (err) {
      console.error('Error submitting feedback:', err);
      if (syncManager && syncManager.showToast) {
        syncManager.showToast(err.message || 'Falha ao enviar feedback.', 'error');
      }
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = `
          <span class="material-symbols-outlined" style="font-size: 20px;">send</span>
          Enviar Feedback
        `;
      }
    }
  });
}
